module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Bold.9505572e.woff";